module.exports = __webpack_public_path__ + "static/media/circo2024_pole_aereo.e20090aa.webp";